export const GET_ANALYTICS_SUCCESS = 'GET_ANALYTICS_SUCCESS';
export const GET_ANALYTICS_FAILURE = 'GET_ANALYTICS_FAILURE';
export const GET_ANALYTICS_REQUEST = 'GET_ANALYTICS_REQUEST';
export const CLEAR_ANALYTICS = 'CLEAR_ANALYTICS';
